export enum SupplierInboxType {
  //inbox
  InboxDirect = 2,
  InboxMatched = 3,
  InboxBidWatch = 4,
  InboxRejected = 5,
  InboxJobAlert = 18,
  //existing jobs
  ExistingUnallocated = 11,
  ExistingWaiting = 12,
  ExistingCompleted = 13,
  ExistingLive = 15,
  ExistingCancelled = 14,
  ExistingClosed = 16,
  InboxRecommendation = 19,
}
